import React from 'react';
import { DropCameraButton } from "../../drop-common";
import { RippleButton } from '@isyc-react/form/modules/base/button';
import { useTranslation } from 'react-i18next';
import { nsformfile } from "../../../../../i18n/namespaces";
import '@isyc-react/design/main';
export const DropSingleDefaultView = props => {
  const {
    open,
    disabled,
    onFile,
    camera
  } = props;
  const {
    t
  } = useTranslation(nsformfile.common);
  return /*#__PURE__*/React.createElement("div", {
    className: "drop-file-default-view-single"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column align-items-center justify-content-center"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "mdi mdi-cloud-upload-outline font-size-50 text-light-grey"
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-2"
  }, t('drop.zone.message')), /*#__PURE__*/React.createElement("div", {
    className: "mt-2 mb-3"
  }, /*#__PURE__*/React.createElement(RippleButton, {
    className: "btn btn-primary",
    onClick: open,
    disabled: disabled
  }, t('drop.zone.button'))), /*#__PURE__*/React.createElement(DropCameraButton, {
    options: camera,
    onFile: onFile,
    disabled: disabled
  })));
};